import React, { useState, useEffect } from "react";
import { pdfjs, Document, Page } from 'react-pdf';
import { Box } from '@mui/joy';
import { Anchor } from "../Typography";
import { useTranslation } from 'react-i18next';
import { Button } from "../Button";

import JSONPretty from 'react-json-pretty';

pdfjs.GlobalWorkerOptions.workerSrc = '/worker/pdf.worker.min.mjs';

const WidgetDocumentPreview = ({ item, downloadable = true }) => {
    const { t } = useTranslation();
    const [url, setUrl] = useState();
    const [numPages, setNumPages] = useState();
    const [pageNumber, setPageNumber] = useState(1);

    useEffect(() => {
        if (item) {
            setUrl(item.url ?? false);
        }
    }, [item]);

    const onDocumentLoadSuccess = (document) => {
        //console.info("onDocumentLoadSuccess", document);
        setNumPages(document._pdfInfo.numPages);
    }

    const onDocumentLoadFail = (document) => {
        console.info("onDocumentLoadFail", document);
    }

    const handlePreviousPage = () => {
        setPageNumber(prevPage => Math.max(prevPage - 1, 1));
    };

    const handleNextPage = () => {
        setPageNumber(prevPage => Math.min(prevPage + 1, numPages));
    };

    const apiBasePath = process.env.REACT_APP_API_ENDPOINT || '';

    return (
        url ? (
            <Box className="form-element form-element-preview-widget col-12">
                {
                    downloadable && (
                        <Anchor href={apiBasePath + url} target="_blank" level="body-small" icon="faDownload" className={"download_document"}>{t('Download')}</Anchor>
                    )
                }
                {
                    item.extension === 'pdf' && url && (
                        <Box className='preview-pdf'>


                            <Document file={url.startsWith("blob:") ? url : apiBasePath + url} onLoadSuccess={onDocumentLoadSuccess} onLoadFail={onDocumentLoadFail}>
                                <Page
                                    pageNumber={pageNumber}
                                    renderAnnotationLayer={false}
                                    renderTextLayer={false}
                                />
                            </Document>

                            <Box className="paginator">
                                <Button onClick={handlePreviousPage} disabled={pageNumber <= 1} icon="faArrowLeft" className={'paginator-previous'}>
                                    {t('Previous')}
                                </Button>

                                <span className="paginator-info">{t('Page {{pageNumber}} of {{numPages}}', { pageNumber: pageNumber, numPages: numPages })} </span>
                                <Button onClick={handleNextPage} disabled={pageNumber >= numPages} icon="faArrowRight" className={'paginator-next'}>
                                    {t('Next')}
                                </Button>
                            </Box>
                        </Box>
                    )
                }
                {
                    ['png', 'jpg', 'jpeg'].includes(item.extension) && (
                        <Box className='preview-image'>
                            <img src={apiBasePath + url} width={500} />
                        </Box>
                    )
                }
            </Box>
        ) : (
            <>
                {/* <JSONPretty data={item} className="json-wrapper"></JSONPretty> */}
            </>
        )
    );
}

export default WidgetDocumentPreview;